import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

export const getPlans = state => (state.plans);

/***************************** Subroutines ************************************/

function * fetchSubscription({ payload: options }) {
  try {
    yield put(Actions.toggleFetchingSubscription(true));
    const { results } = yield call(Api.fetchSubscriptions, options);
    yield put(Actions.fetchSubscriptionSuccess(results));
  }
  catch(ex) {
    yield put(Actions.toggleFetchingSubscription(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * createSubscription({ payload: subscription_props }) {
  try {
    yield put(Actions.toggleCreatingSubscription(true));
    const new_subscription = yield call(Api.createSubscription, subscription_props);
    yield put(Actions.createSubscriptionSuccess(subscription_props));
  }
  catch(ex) {
    yield put(Actions.toggleCreatingSubscription(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * updateSubscription({ payload: subscription }) {
  try {
    yield put(Actions.toggleUpdatingSubscription(true));
    const updated_subscription = yield call(Api.updateSubscription, subscription);
    yield put(Actions.updateSubscriptionSuccess(updated_subscription));
  }
  catch(ex) {
    yield put(Actions.toggleUpdatingSubscription(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * cancelSubscription({ payload: { subscription_id, unpaid } }) {
  try {
    yield put(Actions.toggleCancelingSubscription(true));
    yield call(Api.cancelSubscription, { subscription_id, unpaid });
    yield put(Actions.cancelSubscriptionSuccess());
  }
  catch(ex) {
    yield put(Actions.toggleCancelingSubscription(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * reactivateSubscription({ payload: subscription_id }) {
  try {
    yield put(Actions.toggleUpdatingSubscription(true));
    yield call(Api.reactivateSubscription, { subscription_id });
    yield put(Actions.toggleUpdatingSubscription(false));
  }
  catch(ex) {
    yield call(eventFailed, { payload: ex });
  }
}

function * eventFailed({ payload, notify }) {
  console.log(payload);
  if(notify !== false) {
    yield put(Actions.notify({ message: payload.message || payload }));
  }
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* subscriptionsWatcher() {
  yield* [
    takeEvery(ActionTypes.REQUEST_FETCH_SUBSCRIPTION, fetchSubscription),
    takeEvery(ActionTypes.REQUEST_CREATE_SUBSCRIPTION, createSubscription),
    takeEvery(ActionTypes.REQUEST_UPDATE_SUBSCRIPTION, updateSubscription),
    takeEvery(ActionTypes.REQUEST_CANCEL_SUBSCRIPTION, cancelSubscription),
    takeEvery(ActionTypes.REQUEST_REACTIVATE_SUBSCRIPTION, reactivateSubscription)
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/subscriptions.js